import React from 'react';
import PropTypes from 'prop-types';

import { Container, Icon, Text } from './styles';
import { Images } from '../../themes';

export default function FormSnackbar({ message }) {
  return (
    <Container>
      <Icon src={Images.icons.information} />
      <Text>{message}</Text>
    </Container>
  );
}

FormSnackbar.propTypes = {
  message: PropTypes.string.isRequired,
};
